import React from 'react'
import { useRouter } from 'next/router'
import { useGeoLocation } from '@chegg-wt/core/hooks/useGeoLocation'
import { addQueryStringToRoute } from '@chegg-wt/core/utils/routes'
import { publicUrl } from '@chegg-wt/core/utils/url'
import { LocationCopy } from '@chegg-wt/core/types/core'
import { UpgradeQueryParams } from '@chegg-wt/core/types/upgrade'
import { useRoutesContext } from '../RoutesContext'
import AppLink from '../AppLink'
import * as Styled from './styled'

interface LocationNavBarProps {
  copy: LocationCopy[]
}

export const LocationNavBar: React.FC<LocationNavBarProps> = ({ copy }) => {
  const router = useRouter()
  const { location } = router.query as UpgradeQueryParams
  const { countryCode } = useGeoLocation(location)
  const { toUpgrade } = useRoutesContext()

  const upgradeRoute = (currentLocation: string) =>
    addQueryStringToRoute(toUpgrade(), {
      location: currentLocation,
    })
  return (
    <Styled.LocationFlagContainer>
      {copy.map((value) => (
        <AppLink route={upgradeRoute(value.LocationName)} key={value.LocationName}>
          <Styled.CtaLink data-test={value.LocationName}>
            <Styled.LocationFlagIcon
              key={value.LocationName}
              isBlur={countryCode !== value.LocationName}
              alt={value.alt}
              src={publicUrl(value.imageUrl)}
            />
          </Styled.CtaLink>
        </AppLink>
      ))}
    </Styled.LocationFlagContainer>
  )
}

export default LocationNavBar
